import { Component, Entity, registerComponent } from "aframe";
import { Vector3Like } from "three";
import { SlotComponent, SlotEntity, SlotEvent } from "./slot";


export interface AnchorComponentData
{
	enabled : boolean;
	name? : string;
	slots : string[];
	attach? : boolean;
	//length : number; //TODO
	collisionGroup : string[];
	collisionMask : string[];
	skeleton : boolean;
	squeezeBones: string;
	squeezeScale: Vector3Like;
	label? : string;
	icon? : string;
}


export interface AnchorComponent extends Component
{
	isEntityConnection : true;
	el : AnchorEntity;
	data : AnchorComponentData;
	fits( possibleSlot ? : Entity|null ) : boolean;
	slot? : SlotEntity; //The Slot this Anchor is attached to
	getConnectedEntities( ) : Entity[];
	setSlotPosition( rootEntity : Entity ) : void; //Update rootEntity's position and quaternion to make this Anchor fit rootEntity's parent
};
export type AnchorEntity = Entity< { [attr:string] : Component } & { "anchor" : AnchorComponent } > & 
{
	//Shortcut for scripts
	anchor_slot ? : SlotEntity;
}



//For items that can be taken/put inside a slot
registerComponent("anchor", {
	schema : {
		enabled : { type : "boolean" , default : true },
		name : { type: "string"}, //Name is required when an item has multiple anchors for the same slot
		slots : { type : "array" }, // TYPE of slots this anchor can fit in.
		attach : { type : "boolean", default : true }, //Uses regular Grab interactions to attach to slots.
		//length : { type : "number", default : 0.0 }, //TODO
		collisionGroup : { type : "array" }, //Collision Group of the "item" when this Anchor is in a Slot
		collisionMask : { type : "array" }, //Collision Mask of the "item" when this Anchor is in a Slot
		skeleton : { type:"boolean", default: false },
		squeezeBones: { type:"string" },
		squeezeScale: { type:"vec3", default: { x:0.2, y:1, z:0.2 }},
		label: { type:"string" },
		icon: { type:"string" }

	},

	init(this : AnchorComponent )
	{
		this.isEntityConnection = true;

		this.el.addEventListener("attached-to-slot", (event) =>
		{
			if(event.target === this.el)
			{
				this.el.anchor_slot =	this.slot = (event as SlotEvent).detail.slot;
			}
		});
		this.el.addEventListener("detached-from-slot", (event) =>
		{
			if(event.target === this.el)
				if( this.slot === (event as SlotEvent).detail.slot )
				{
					delete this.el.anchor_slot;
					delete this.slot;
				}
		});
	},

	getConnectedEntities(this : AnchorComponent) 
	{
		return this.slot ? [this.slot] : [];
	},

	fits(this : AnchorComponent, entity? : Entity)
	{
		const slot = entity && entity.components.slot as SlotComponent;
		if( slot && this.data.slots.includes(slot.data.type || slot.data.name) )
		{
			const accept = slot.data.accept;
			if(accept && accept.length)
			{
				for(let selector of accept)
					if(this.el.matches(selector))
						return true;
			}
			else
				return true;

		}
		return false;
	},

	setSlotPosition(this : AnchorComponent, el : Entity)
	{
		if(el === this.el) //Anchor and el are the same : just identity.
		{
			el.object3D.position.set(0,0,0);
			el.object3D.quaternion.set(0,0,0,1);
			return;
		}
		
		const aObj = this.el.object3D;
		el.object3D.quaternion.copy(aObj.quaternion); //.conjugate();
		el.object3D.position.copy(aObj.position);
		for(let p = aObj.parent; p && p !== (el.object3D); p = p.parent )
		{
			el.object3D.position.applyMatrix4( p.matrix );
			el.object3D.quaternion.premultiply( p.quaternion );
		}
		el.object3D.quaternion.conjugate();
		el.object3D.position.negate().applyQuaternion(el.object3D.quaternion);
	},

	update(this : AnchorComponent, oldData : AnchorComponentData)
	{
		if(oldData)
			if(oldData.slots || oldData.enabled)
			{
				//This changes whether/how this anchor interacts with slots
				this.el.emit("interactions-changed");
			}
	}
})


